import { NgModule } from '@angular/core';
import { CapitalizePipe } from '@pipes/capitalize.pipe';
import { FileSizePipe } from '@pipes/file-size.pipe';
import { Nl2BrPipe } from '@pipes/nl2br.pipe';
import { TranslateCutPipe } from '@pipes/translateCut.pipe';

const PIPES = [
   CapitalizePipe,
   TranslateCutPipe,
   Nl2BrPipe,
   FileSizePipe,
];

@NgModule({
   declarations: PIPES,
   exports: PIPES,
})
export class PipeModule { }
